// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__cNzYE","footer":"ModalCreateQualiphyProcedure_footer__2Bm5t","additionData":"ModalCreateQualiphyProcedure_additionData__UfR1W"};